export enum TransferType {
	AgentWarmCallTransfer = 1,
	AgentColdCallTransfer = 2,
	IvrColdTransfer = 3,
	MessagingAgentTransfer = 4,
	MessagingAgentTransferToQueue = 5,
	EmailAgentTransfer = 6,
	EmailAgentTransferToQueue = 7,
	IvrWarmTransfer = 9,
	AgentTransfer = 10,
	IvrTransfer = 11,
	WhatsAppAgentTransfer = 12,
	WhatsAppTransferToQueue = 13,
	WebchatAgentTransfer = 14,
	WebchatTransferToQueue = 15,
	AgentRouteCallTransfer = 16,
	AssignToAgent = 17,
	VoicemailTransferToAgent = 18,
	VoicemailTransferToQueue = 19,
}

export enum InteractionActionPopoverType {
	InteractionNote = 8,
	Mute = 9,
	Summary = 10,
}

export type InteractionPopoverType =
	| TransferType
	| InteractionActionPopoverType;

export enum WarmTransferActionType {
	ConsultAgent = 1,
	ConsultCaller = 2,
	Finalize = 3,
	Cancel = 4,
	ConferenceMode = 5,
}

export enum ColdTransferType {
	None = 0,
	Agent = 1,
	Queue = 2,
	Flow = 3,
}

export interface StartTransferModel {
	type?: TransferType;
	target?: string;
}

export interface InitiateTransferRequest extends StartTransferModel {
	transferTarget?: string;
	messagingId?: string;
	transferTargetString?: string;
	transferInitiatorUserId?: string;
	onTransferCallback?: () => void;
}

export interface TransferStartResponse {
	contactNotFound: boolean;
	contactUnavailable: boolean;
	transferStarted: boolean;
	transferAlreadyInProgress: boolean;
	invalidCall: boolean;
	routeCallDisabled: boolean;
	contactNotSupported: UnsupportedContactType;
	multipleContactsWithSameSip: boolean;
	//#warning-ts: [to-be-done] make presenceActivity a ts enum, and make IsTargetUnavailable return it a cs enum, with both enums being in sync; the translateActivity function's parameter should take use this enum instead of string, and we would translate based on the enum's string value
	presenceActivity?: string;
	isTeamsPresenceDndOverride?: boolean;
}

export enum UnsupportedContactType {
	NA = 0,
	CallQueueOrAutoAttendant = 1,
	IVRQueue = 2,
	IVRFlow = 3,
}

// What a contact has to carry for the transfer dialog to be able to offer it. The dialog asks the server
// for these rather than dropping the rest once they have come back, so a page it is offered holds the
// contacts it can reach and the total and the next-page decision count the same ones.
export enum TransferTargetKind {
	None = 0,
	Address = 1,
	AddressOrPhone = 2,
}

export enum TransferChannelType {
	Voice = 1,
	Generic = 2,
	Email = 3,
	WhatsApp = 4,
	WebChat = 5,
	Voicemail = 6,
}
